import { makeStyles } from "@material-ui/core";

export const useEventCardStyles = makeStyles(
  _ => ({
    activitySpan: {
      color: "#247CFF",
      cursor: "pointer",
      fontSize: "10px",
      marginLeft: "5px",
      textDecoration: "underline"
    },
    dot: {
      color: "#0030FF",
      left: "-12px",
      position: "absolute",
      top: "-5px"
    },
    eventName: {
      color: "#002972",
      fontWeight: "bold",
      lineHeight: "1.25"
    },
    eventStatus: {
      alignItems: "center",
      color: "#747C8C",
      display: "flex",
      fontSize: "0.95rem",
      fontWeight: "bold"
    },
    eventStatusGreen: {
      color: "#00C6A2"
    },
    eventStatusRed: {
      color: "#EC5D77"
    },
    paper: {
      backgroundColor: "#fff",
      borderRadius: "8px",
      margin: "10px 0",
      overflow: "hidden",
      padding: "0",
      width: "100%"
    },
    rowArrowIcon: {
      color: "#0030FF",
      fontSize: "1rem",
      margin: "0 8px"
    },
    rowBadge: {
      borderBottomRightRadius: "10px",
      fontSize: "12px",
      fontWeight: "bold",
      height: "25px",
      left: "0px",
      minWidth: "30px",
      padding: "2px 10px",
      position: "absolute",
      top: "0px"
    },
    rowBadgeCustomOrange: {
      backgroundColor: "#FF8122",
      color: "#FFFFFF"
    },
    rowBadgeCustomPurple: {
      backgroundColor: "#3C5BCD",
      color: "#FFFFFF"
    },
    rowBadgeError: {
      backgroundColor: "#EC5D77",
      color: "#FFFFFF"
    },
    rowBadgeInfo: {
      backgroundColor: "#DCE4FF",
      color: "#002972"
    },
    rowBadgePrimary: {
      backgroundColor: "#247CFF",
      color: "#FFFFFF"
    },
    rowBg: {
      backgroundColor: "#F4F8FF"
    },
    rowLabel: {
      color: "#002972",
      fontSize: "0.9rem",
      fontWeight: "bold",
      marginRight: "10px"
    },
    rowLabelMinWidthLong: {
      minWidth: "180px"
    },
    rowLabelMinWidthShort: {
      minWidth: "130px"
    },
    rowLabelTextGray: {
      color: "#494E56"
    },
    rowLi: {
      alignItems: "center",
      display: "flex",
      fontWeight: 550
    },
    textGray: {
      color: "#747C8C",
      fontWeight: 400
    },
    timelineBox: {
      "&:last-child > div": {
        borderLeft: "none"
      },
      padding: "0 16px"
    },
    timelineContainer: {
      borderLeft: "1px solid #CED3DD",
      paddingBottom: "15px",
      paddingLeft: "10px",
      position: "relative"
    },
    timelineItem: {
      alignItems: "flex-start",
      display: "flex",
      justifyContent: "space-between",
      padding: "5px 0 5px 20px",
      position: "relative",
      transform: "translateY(-8px)"
    },
    updateRow: {
      fontSize: "0.9rem",
      padding: "10px 10px 5px",
      position: "relative",
      width: "100%"
    }
  }),
  { name: "EventCardStyles" }
);
